<template>
  <main>

    <div class="hero_in detail_page background-image" data-background="url(img/restaurant_detail_hero.jpg)"
         :style="{ backgroundImage: 'url(' + getPathFileBackgroundImage(this.merchant.image) + ')' }">
      <div class="wrapper opacity-mask" data-opacity-mask="rgba(0, 0, 0, 0.5)"
           style="background-color: rgba(0, 0, 0, 0.5);">

        <div class="container">
          <div class="main_info">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8">
                <div class="head">
                  <!--                  <div class="score"><span>Superb<em>350 Reviews</em></span><strong>8.9</strong></div>-->
                </div>
                <h1>{{ this.merchant.name }}</h1>
                {{ this.merchant.location.address }}
                <br>
                Giờ mở cửa : {{ convertUTC7(this.merchant.time_open) }}:00 - {{ convertUTC7(this.merchant.time_close) }}:00
              </div>
            </div>
            <!-- /row -->
          </div>
          <!-- /main_info -->
        </div>
      </div>
    </div>
    <!--/hero_in-->

    <div class="container margin_detail shop-detail">
      <div class="row">
        <div class="col-lg-12">
          <div class="btn-container d-flex">
            <input v-model="type_ship" type="radio" value="1" name="food" id="pizza" checked hidden/>
            <label style="text-align: center;padding-top: 15px" id="in-shop" for="pizza">Mua tại cửa hàng</label>
            <input v-model="type_ship" type="radio" value="2" name="food" id="pasta" hidden/>
            <label style="text-align: center" id="in-ship" for="pasta">Giao hàng
              <p style="margin-bottom: 0">  <span v-html="duration"></span> phút - <span v-html="distance">20</span> km</p>

            </label>
          </div>
<!--          <div class="row" v-if="type_ship == 2">-->
<!--            <div class="content-deli">-->
<!--              <div class="box-deli">-->
<!--                <div class="item-deli">-->
<!--                <span class="span1">-->
<!--                  15-20-->
<!--                </span> <br>-->
<!--                  <span>-->
<!--                  phút-->
<!--                </span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="tabs_detail">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item">
                <a id="tab-A" href="#pane-A" class="nav-link active" data-toggle="tab" role="tab">Thực đơn</a>
              </li>
              <li class="nav-item">
                <a id="tab-B" href="#pane-B" class="nav-link" data-toggle="tab" role="tab">Thông tin cửa hàng</a>
              </li>
            </ul>

            <div class="tab-content" role="tablist">
              <div id="pane-A" class="card tab-pane fade show active" role="tabpanel" aria-labelledby="tab-A">
                <div class="card-header" role="tab" id="heading-A">
                  <h5>
                    <a class="show" data-toggle="collapse" href="#collapse-A" aria-expanded="true"
                       aria-controls="collapse-A">
                      Thực đơn
                    </a>
                  </h5>
                </div>
                <div id="collapse-A" class="collapse show" role="tabpanel" aria-labelledby="heading-A">
                  <div class="card-body info_content">
                    <div class="special_offers add_bottom_45">
                      <div>
                        <div class="outer-container">
                          <div id="eight-day-sticky-section-sticky-wrapper" class="sticky-wrapper">
                            <div id="eight-day-sticky-section" class="sticky-section">
                              <div class="scrollmenu-fade">
                                <div class="scrollmenu">
                                  <p class="scroll-display-arrow-right"><i class="fas fa-angle-left"></i></p>
                                  <p class="scroll-display-arrow-left"><i class="fas fa-angle-right"></i></p>
                                  <a v-for="(cate,index) in this.merchant.categories"
                                     style="cursor: pointer"
                                     :scrollTo="`#cate-pr-${index}`"
                                     onclick="scrollCategory($(this))"
                                     class="active-highlight" :class="index == 0 ? 'tour-details-section-active' : 0">
                                    {{ cate.name }}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <template v-if="this.merchant.categories.length > 0">
                            <div v-for="(cate,index) in this.merchant.categories" :id="`cate-pr-${index}`"
                                 class="tour-details-section">
                              <div class="center">
                                <h3>{{ cate.name }}</h3>
                                <div class="menu-gallery">
                                  <div v-for="product in cate.products" class="menu_item thumbs">
                                    <figure>
                                      <a href="/static/images/menu_item_large_1.jpg" title="" data-effect="mfp-zoom-in">
                                        <img :src=getPathFile(product.image.path)
                                             :data-src=getPathFile(product.image.path) alt="" class="lazy">
                                      </a>
                                    </figure>
                                    <div>
                                      <h4>{{ product.name }}</h4>
                                      <p class="txt-product">
                                        <span>{{ product.description }}</span>
                                        <button @click.prevent="addToCart(product)" class="btn_1 btn-add-to-cart"><i
                                          class="icon_plus"></i></button>
                                      </p>
                                      <h6><b>{{ convertCurrency(product.price) }}</b></h6>
                                    </div>
                                  </div>
                                </div>
                                <!-- /menu-gallery -->
<!--                                <hr>-->
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /tab -->

              <div id="pane-B" class="card tab-pane fade" role="tabpanel" aria-labelledby="tab-B">
                <div class="card-header" role="tab" id="heading-B">
                  <h5>
                    <a class="collapsed" data-toggle="collapse" href="#collapse-B" aria-expanded="true"
                       aria-controls="collapse-B">
                      Thông tin cửa hàng
                    </a>
                  </h5>
                </div>
                <div id="collapse-B" class="collapse" role="tabpanel" aria-labelledby="heading-A">
                  <div class="card-body info_content">
<!--                    <p>{{ this.merchant.description }}</p>-->
<!--                    <div class="add_bottom_25"></div>-->
<!--                    <h2>Thư viện ảnh</h2>-->
<!--                    <div class="pictures magnific-gallery clearfix">-->
<!--                    </div>-->
                    <!-- /menu-gallery -->

                    <div class="other_info">
                      <div class="row">
                        <div class="col-md-4">
                          <h3>Địa chỉ</h3>
                          <p>{{ this.merchant.location.address }}<br></p>
                          <strong>Mạng xã hội</strong><br>
                          <p class="follow_us_detail"><a href="#0"><i class="social_facebook_square"></i></a><a
                            href="#0"><i class="social_instagram_square"></i></a><a href="#0"><i
                            class="social_twitter_square"></i></a></p>
                        </div>
                        <div class="col-md-4">
                          <h3>Thời gian mở cửa</h3>
                          <p><strong>{{ convertUTC7(this.merchant.time_open) }}:00 - {{ convertUTC7(this.merchant.time_close) }}:00</strong></p>
                          <p>
                          <p><span class="loc_closed">Tất cả các ngày trong tuần</span></p>
                        </div>
                        <div class="col-md-4">
                          <h3>Dịch Vụ</h3>
                          <p><strong>Thanh Toán</strong><br> Mastercard, Visa, AlePay</p>
<!--                          <p><strong>Khác</strong><br> Wifi Free, Chỗ để xe ,...</p>-->
                        </div>
                      </div>
                      <!-- /row -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /tab-content -->
          </div>
          <!-- /tabs_detail -->
        </div>
        <!-- /col -->
<!--        <CartSideBar/>-->

      </div>
    </div>
    <!-- /container -->
  <CartBottom />
  </main>
</template>

<script>
import HeaderShop from "../components/Header-Shop";
import CartSideBar from "../components/CartSideBar";
import {mapActions, mapGetters} from "vuex";
import {isEmptyObject} from "../helpers";
import CartBottom from "../components/CartBottom";
import {config} from "../constants/config";
export default {
  name: "DetailShop",
  data() {
    return {
      merchant: null,
      type_ship : 1,
      duration: 0,
      distance: 0,
    }
  },
  components: {CartBottom, CartSideBar, HeaderShop},
  mounted() {
    this.$store.commit('SHOW_DROPDOWN_CART',false)
  },
  computed: {
    ...mapGetters(['getterAddressUser'])
  },
  methods: {
    ...mapActions(['getMerchantDetail', 'actionAddToCart','matrixByMerchant']),
    convertCurrency(x) {
      return x.toLocaleString('vi-VN') + ' VNĐ'
    },
    getPathFile(src) {
      return src;
    },
    getPathFileBackgroundImage(image) {
      return image != null && image.path != undefined ? image.path : '/static/images/restaurant_detail_hero.jpg'
    },
    addToCart(product) {
      let isOpenCurrent = this.checkOpenTime(this.convertUTC7(this.merchant.time_open),this.convertUTC7(this.merchant.time_close));
      if (!isOpenCurrent){
        alert('Cửa hàng đã đóng cửa , vui lòng quay lại sau !')
        return false;
      }
      this.actionAddToCart({product: product, merchant: this.merchant});
    },
    checkOpenTime(timeOpen,timeClose){
      if (timeOpen === undefined || timeClose === undefined) return false;
      let hourCurrent = new Date().getHours()
      return hourCurrent >= timeOpen && hourCurrent <= timeClose
    },
    convertUTC7(time){
      return config.timeUTV7[time]
    }
  },
  created() {
    this.$store.commit('SHOW_LOADING',true);
    this.getMerchantDetail(this.$route.params.slug).then(res => {
      // console.log('res', res)
      this.$store.commit('SHOW_LOADING',false);
      if (!res) {
        this.$router.push('/error-page')
      }
      if (res.data.status_code == 200) {
        this.merchant = res.data.data
        this.matrixByMerchant({merchantId: this.merchant.id,addressUser: this.getterAddressUser})
          .then(res=>{
            this.duration = Math.floor(res.data.data.duration / 60)
            this.distance = (res.data.data.distance / 1000).toFixed(2)
          })
          .catch(e=>{
            console.log('e matrixByMerchant VIEW', e)
          })
      } else {
        this.$router.push('/error-page')
      }
    }).catch(e => {
      this.$store.commit('SHOW_LOADING',false);
      console.log('e', e)
    })

  }
}
</script>

<style scoped>
.outer-container {
  width: 100vw;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  -webkit-transition: width 1s;
  -o-transition: width 1s;
  transition: width 1s;
}

.outer-container.active {
  width: 500px !important;
  -webkit-transition: width 1s;
  -o-transition: width 1s;
  transition: width 1s;
}

.tour-details-section {
  padding-top:30px
}

.center {

}

.center p {

}

#cate-pr-1,
#dates,
#map,
#book {

}

#cate-pr-2,
#includes-excludes,
#gallery {

}


/* Sticky nav */
#eight-day-sticky-section .tour-details-section-active {
  border-bottom: 3px solid #fac264;
}


.sticky-section {
  z-index: 19 !important;
}

.scrollmenu-fade {
  position: relative;
  z-index: 999;
  width: 90%;
  margin: auto;
}

.scrollmenu-fade:after {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 15px;
  pointer-events: none;
  width: 15%;
  height: 46px;
}

div.scrollmenu {
  background-color: #fbfbfb;
  overflow: auto;
  white-space: nowrap;
  text-align: center;
  overflow-y: hidden;
  overflow-x: hidden;
}

div.scrollmenu a {
  display: inline-block;
  color: black;
  font-weight: 600;
  text-align: center;
  padding: 14px 14px 10px 14px;
  text-decoration: none;
}

div.scrollmenu p {
  display: inline-block;
  color: black;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

/* Media queries */

@media only screen and (min-width: 650px) {
  div.scrollmenu p.scroll-display-arrow {
    display: none;
  }
}

@media only screen and (max-width: 650px) {
  .scrollmenu-fade:after {
    height: 82px !important;
  }

  #change-button {
    display: none;
  }

  .hide-mobile {
    display: none;
  }
  .tour-details-section {
    border-bottom: 1px solid lightgrey;
  }
}

html {
  scroll-behavior: smooth;
}

.payment_select {
  margin-bottom: 0;
}

label {
  position: relative;
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
  width: 208px;
  padding: 5px 0;
  color: black;
  transition: all 0.3s ease;
}

#pizza + label:before {
  /*content: "";*/
  /*width: 100%;*/
  /*height: 100%;*/
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 100%;*/
  /*z-index: -1;*/
  /*background-color: #fac264;*/
  /*transition: all 0.3s ease;*/
}
#pizza:checked + label:before {
  left: 0;
}

#pizza:checked + label,
#pasta:checked + label {
  color: #fff;
  background: indianred;
  transition: ease 0.3s;
}

#pasta + label[data-v-2e4c510b]:before {
  width: 58%;
}

label[for=pasta] {
  text-align: center;
}
label#in-shop{
  border-radius: 30px 0 0 30px;
  border: 1px solid lightgrey;
}
label#in-ship{
  border-radius: 0 30px 30px 0;
  border: 1px solid lightgrey;
}
@media (min-width: 1024px) {
  .menu-gallery{
    display: flex;
  }
  .menu_item.thumbs{
    width: 30%;
    margin-right: 25px;
    min-height: 125px;
    border:1px solid lightgrey;
    padding-left: 140px;
  }
  .menu_item.thumbs figure img{
    width: 125px;
    height: 123px;
    object-fit: cover;
  }
  .menu_item.thumbs figure{
    margin: 0;
    width: 125px;
    height: 125px;
  }
  .btn-add-to-cart{
    right: 15px;
    bottom: 15px;
  }
  .info_content hr{
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DetailShop.vue